export const BOOKING_STATUSES = [
  { id: "CMP", intent: null, name: "Completed" },
  { id: "INW", intent: null, name: "Inwarding" },
  { id: "BKD", intent: null, name: "Booked" },
  { id: "CFA", intent: null, name: "Confirmed by Aggregator" },
  { id: "CFF", intent: null, name: "Confirmed by Supplier" },
  { id: "PKD", intent: null, name: "Picked up" },
  { id: "CNL", intent: null, name: "Cancelled" },
]
